import { axiosInstance } from '@/services/axiosInstance'

export const EquipamentosResource = {
  getLista: (parametros) => {
    return axiosInstance.get(
      'v1/Device',
      {
        params: parametros
      }
    )
  },
  getStatus: () => {
    return axiosInstance.get('v1/DeviceStatus')
  },

  getStatusTotals: () => {
    return axiosInstance.get('v1/Device/bystatustotals')
  },
  getEquipamento: (parametros) => {
    return axiosInstance.get(
      'v1/Device/:idDevice', {
      urlParams: parametros
    }
    )
  },
  register: (parametros) => {
    return axiosInstance.post('v1/device',
      parametros
    )
  },

  update: (parametros) => {
    return axiosInstance.put('v1/device',
      parametros
    )
  },

  listWithLastTransaction: (parametros) => {
    return axiosInstance.get(
      'v1/Device/listwithlasttransaction',
      {
        params: parametros
      }
    )
  },

}